<app-link-card-container
	[id]="link()?.value?.id"
	[isLoading]="isLoading()"
	[pillColor]="link()?.pillColor"
	[module]="moduleUrl()"
	[files]="link()?.value?.files"
	[statusValue]="link()?.value?.status"
	[title]="link()?.value.code">
	<div class="py-4">
		<app-expected-at-pill
			class="bg-neutral-100 dark:bg-neutral-800 p-2"
			[startsAt]="link()?.value?.startsAt"
			[endsAt]="link()?.value?.endsAt" />
	</div>
</app-link-card-container>
